import { useContext, useEffect, useState } from "react";
import styles from "../styles/ChatbotSettings.module.css";
import { LanguageContext } from "./App";
import React from "react";
import { buttonVariants } from "./ui/button.tsx";
import { PiSignOut } from "react-icons/pi";
import { SupabaseContext } from "./Login.js";

export default function AccountSettings() {
  const [language, setLanguage] = useContext(LanguageContext);
  const supabase = useContext(SupabaseContext);

  return (
    <div className={styles.main}>
      <div
        style={{
          borderRadius: 12,
          width: "50vw",
          right: 0,
          margin: 20,
          padding: 20,
          height: "100vh",
          fontFamily: "Jost",
          fontWeight: 600,
          scrollbarWidth: "none",
        }}
      >
        <div className="radio">
          <label style={{ fontFamily: "Jost", fontWeight: 600, color: "#000" }}>
            <input
              color="#16a34a"
              type="checkbox"
              checked={language === "en"}
              onChange={() => {
                // setLanguage("en");
                window.open(
                  "https://cyberchat-dashboard.vercel.app/?la=en",
                  "_self"
                );
              }}
            />{" "}
            English
          </label>
        </div>
        <div className="radio">
          <label style={{ fontFamily: "Jost", fontWeight: 600, color: "#000" }}>
            <input
              color="#16a34a"
              type="checkbox"
              checked={language === "ru"}
              onChange={() => {
                // setLanguage("ru");
                window.open(
                  "https://cyberchat-dashboard.vercel.app/?la=ru",
                  "_self"
                );
              }}
            />{" "}
            Русский
          </label>
        </div>

        <button
          className={buttonVariants({ variant: "signout" })}
          style={{
            marginLeft: -16,
            position: "absolute",
            bottom: "0px",
            marginBottom: 40,
          }}
          onClick={async () => {
            await supabase.auth.signOut();
          }}
        >
          <PiSignOut size={17} />
          <a
            style={{
              color: "#000",
              marginLeft: 10,
            }}
          >
            {language === "en" ? "Sign out" : "Выйти"}
          </a>
        </button>
        <h3
          className={styles.value}
          id={styles.changingValue}
          style={{
            fontSize: 10,
            position: "absolute",
            bottom: "0px",
          }}
        >
          {language === "en"
            ? `Medvedev Artemiy Ilyich. TIN 667473072400; Phone: +7 (982) 600 53-77; E-mail: artemy.medvedev.ilyich@gmail.com`
            : `Медведев Артемий Ильич. ИНН 667473072400; Телефон: +7 (982) 600 53-77; E-mail: artemy.medvedev.ilyich@gmail.com`}
        </h3>
      </div>
    </div>
  );
}
